import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Registration } from './pages/registration/registration';
import { Dashboard } from './pages/dashboard/dashboard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Header } from './header/header';
import { Home } from './home/home';
import { Login } from './pages/login/login';
import { CourseDetails } from './pages/course-details/course-details';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { VideoMain } from './pages/video-main/video-main';
import { VideoCmodel } from './pages/video-cmodel/video-cmodel';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CourseMain } from './pages/course-main/course-main';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CourseDetailsEvolvingTeaching } from './pages/course-details-evolving-teaching/course-details-evolving-teaching';
import { CourseMainEvolvingteaching } from './pages/course-main-evolvingteaching/course-main-evolvingteaching';
import { Footer } from './footer/footer';
import { Loader } from './loader/loader';
import { Chat } from './pages/chat/chat';
import { BookLiveSessionSlot } from './pages/book-live-session-slot/book-live-session-slot';
import { SlotConfirmation } from './pages/slot-confirmation/slot-confirmation';
import { NodataFound } from './pages/nodata-found/nodata-found';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { Feedback } from './feedback/feedback';
import { CommentsModal } from './comments-modal/comments-modal';

@NgModule({
  declarations: [
    App,
    Registration,
    Dashboard,
    Header,
    Home,
    CourseDetails,
    CourseMain,
    VideoMain,
    VideoCmodel,
    Login,
    CourseDetailsEvolvingTeaching,
    CourseMainEvolvingteaching,
    Footer,
    Loader,
    Chat,
    BookLiveSessionSlot,
    SlotConfirmation,
    NodataFound,
    Feedback,
    CommentsModal
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
  BrowserModule,
  BrowserAnimationsModule,   
  AppRoutingModule,
  ReactiveFormsModule,
  FormsModule,
  NgbModule,
  MatIconModule,
  ToastrModule.forRoot({    
    timeOut: 3000,
    positionClass: 'toast-center-center',
    preventDuplicates: true,
    toastClass: 'ngx-toastr custom-width-toast'
  }),
],

  providers: [
  provideBrowserGlobalErrorListeners(),
  provideClientHydration(withEventReplay()),

  provideHttpClient(withInterceptorsFromDi()), // ✅ FIXED

  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }
],
  bootstrap: [App]
})
export class AppModule { }
